import { MGrid, MSpinner } from "components/Shared";
import { InternetUserListDto } from "interfaces/Mueller.Business.Models";
import React, { useEffect, useRef, useState } from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import { getUserListWithSearch } from "requests/internetUsers";
import SearchIcon from "@mui/icons-material/Search";
interface Props {
  onInternetUserSelected: (user: InternetUserListDto) => any;
}

const InternetUserSearch = (props: Props) => {
  const [searchedInternetUsers, setSearchedInternetUsers] = useState<InternetUserListDto[]>(null);
  const [selectedInternetUser, setSelectedInternetUser] = useState<InternetUserListDto>(null);
  const [searchTerm, setSearchTerm] = useState<string | number>(null);
  const [isSearchingUsers, setIsSearchingUsers] = useState<boolean>(false);

  const mounted = useRef<boolean>(true);

  useEffect(() => {
    return () => {
      mounted.current = false;
    };
  }, []);

  const colDefs = [
    { key: "internetuserid", dataSource: "internetUserId", name: "Internet User Id" },
    { key: "username", dataSource: "username", name: "Username" },
    { key: "email", dataSource: "email", name: "Email Address" },
  ];

  const onUserFetchSuccess = (users: InternetUserListDto[]) => {
    let activeUsers = users.filter((u) => u.isDisabled === false);
    setSearchedInternetUsers(activeUsers);
    setIsSearchingUsers(false);
  };

  const onSearch = () => {
    setIsSearchingUsers(true);
    getUserListWithSearch(searchTerm, onUserFetchSuccess, mounted);
  };

  return (
    <>
      {selectedInternetUser ? (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1, alignItems: "center" }}>
          <Box sx={{ width: "100%", fontSize: "1rem" }}>
            <Typography>Selected Internet User</Typography>
            <List>
              <ListItem><ListItemText primary="Internet User Id" secondary={selectedInternetUser.internetUserId} slotProps={{ primary: { fontWeight: "bold" } }} /></ListItem>
              <ListItem><ListItemText primary="Username" secondary={selectedInternetUser.username} slotProps={{ primary: { fontWeight: "bold" } }} /></ListItem>
              <ListItem><ListItemText primary="Email" secondary={selectedInternetUser.email} slotProps={{ primary: { fontWeight: "bold" } }} /></ListItem>
            </List>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, flexGrow: 1, width: "100%", }}>
            <Button onClick={() => setSelectedInternetUser(null)}>Back</Button>
            <Button onClick={() => props.onInternetUserSelected(selectedInternetUser)}>Select</Button>
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 1,
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
              gap: 1,
              justifyContent: "flex-start",
              flexGrow: 1,
              width: "100%",
            }}
          >
            <TextField
              variant="standard"
              label="Search Text"
              onChange={(e) => setSearchTerm(e.target.value)}
              sx={{ flexGrow: 1 }}
            />
            <Button onClick={() => onSearch()}>
              <SearchIcon />
            </Button>
          </Box>
          {isSearchingUsers ? (
            <MSpinner />
          ) : (
            searchedInternetUsers && (
              <MGrid
                columnDefinitions={colDefs}
                data={searchedInternetUsers}
                onRowClick={(i) => setSelectedInternetUser(searchedInternetUsers[i])}
              />
            )
          )}
        </Box>
      )}
    </>
  );
};

export default InternetUserSearch;
